var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn && _vm.isDebug && _vm.$route.path == '/menu')?_c('div',[_c('pre',[_vm._v(_vm._s({ tikklok: _vm.tikklok, userLocation: _vm.userLocation }))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }